import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const videos = [
    { title: 'Introduction', time: '01:46', href: '/videos/Introduction.mp4' },
    { title: 'How it Works', time: '02:43', href: '/videos/How it Works.mp4' },
    { title: 'Tutorial', time: '03:02', href: '/videos/Tutorial.mp4' },
    { title: 'Tech Break Down', time: '03:02', href: '/videos/Tech Break Down.mp4' },
];

const Header: React.FC = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <AppBar
            position="fixed"
            sx={{
                backgroundColor: '#000000',
                px: { xs: 2, md: 8 },
                boxShadow: 'none',
            }}
        >
            <Toolbar disableGutters sx={{ width: '100%' }}>
                <Box
                    component="a"
                    href="/"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        textDecoration: 'none',
                    }}
                >
                    <Box
                        component="img"
                        src="/images/gen-ai-logo.png"
                        alt="Gen AI Logo"
                        sx={{
                            height: { xs: 60, md: 80 },
                        }}
                    />
                </Box>

                <Box sx={{ flexGrow: 1 }} />
                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 3 } }}>
                    <Box
                        onClick={handleClick}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            color: '#8378ff',
                            fontSize: { xs: '0.9rem', md: '1rem' },
                            fontWeight: 500,
                            '&:hover': { textDecoration: 'underline' },
                        }}
                    >
                        <Typography
                            component="span"
                            sx={{
                                color: '#8378ff',
                                textTransform: 'none',
                                fontSize: { xs: '0.9rem', md: '1rem' },
                                fontWeight: 500,
                            }}
                        >
                            Learn More
                        </Typography>
                        <ArrowDropDownIcon
                            sx={{
                                color: '#8378ff',
                                fontSize: { xs: '1rem', md: '1.5rem' },
                                ml: 0.5,
                            }}
                        />
                    </Box>

                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{ sx: { backgroundColor: '#121212', color: '#fff' } }}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >
                        {videos.map((video) => (
                            <MenuItem
                                key={video.title}
                                component="a"
                                href={video.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={handleClose}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    gap: 1,
                                    fontSize: '0.9rem',
                                    color: '#fff',
                                    '&:hover': { backgroundColor: '#2e2e2e' },
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <PlayArrowIcon fontSize="small" sx={{ color: '#8378ff' }} />
                                    {video.title}
                                </Box>
                                <Typography variant="body2" sx={{ opacity: 0.7 }}>
                                    {video.time} min
                                </Typography>
                            </MenuItem>
                        ))}
                    </Menu>

                    <Button
                        variant="outlined"
                        href="mailto:earlyaccess@genaisignal.com"
                        sx={{
                            color: '#8378ff',
                            borderColor: '#8378ff',
                            textTransform: 'none',
                            fontSize: { xs: '0.8rem', md: '1rem' },
                            borderRadius: '6px',
                            px: { xs: 2, md: 3 },
                            py: { xs: 0.8, md: 1 },
                            fontWeight: 500,
                            '&:hover': {
                                backgroundColor: '#8378ff',
                                color: '#fff',
                            },
                        }}
                    >
                        Early Access
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
